<template>
    <div class="container-fluid mt--7">
        <div class="card mb-3">
            <div class="row no-gutters">   
                <div class="col-md" style="padding: 15px; padding-left: 25px;">
                    <div class="row">
                        <div class="col-md-10">
                            <h3 class="mb-3">Barcode Printing Template</h3>
                        </div>
                        <div class="col-md-2">
                            <a-button type="primary" class="btn float-right ml-1 btn-primary btn-sm" @click="showDrawer('add')"> + Add</a-button>
                        </div>
                    </div>
                    <!-- <a-table rowKey="id" size="small" :customRow="pendingDocumentsEvent" :columns="pendingDocumentsColumn" :data-source="pendingDocuments" />         -->
                    <a-table rowKey="id" size="small" :data-source="barcodeTemplateList" :columns="columns">
                            <template slot="action" slot-scope="action">
                                <a-button type="primary" v-if="!action.is_default" class="mr-2" @click="editBarcodeTemplate(action)"> Edit</a-button>
                                <a-button type="primary" class="mr-2" @click="viewBarcodeTemplate(action)"> View</a-button>
                                <a-popconfirm v-if="!action.is_default"  title="Are you sure you want to delete this option?" @confirm="() => deleteBarcodeTemplate(action.id)">
                                    <a-button type="danger" >Delete</a-button>
                                </a-popconfirm>
                            </template>
                    </a-table>   
                </div>
            </div>
        </div>
        <a-drawer
            placement="right"
            :width="480"
            :visible="drawerVisible"
            @close="closeDrawer"
        >
            <h6 class="heading-small text-muted mb-4">{{currentAction == 'edit' ? "Edit" : currentAction == 'add' ? "Add" : "View" }} Barcode Printing Template</h6>
            <base-alert v-if="barcodeTemplateErrors.length" type="danger">
                <b>You have the following error(s):</b>
                <li v-for="error in barcodeTemplateErrors" :key="error">{{ error }}</li>
            </base-alert>
            <fieldset :disabled="this.currentAction == 'view'">
                <base-input v-model="barcodeTemplate.name" label="Name" placeholder="" input-classes="form-control" required/>
                <base-input v-model="description.printer_model" label="Printer Model" placeholder="" input-classes="form-control" required/>
                <base-input v-model="description.sticker_size" label="Sticker Size" placeholder="" input-classes="form-control" required/>
                <base-input v-model="description.sticker_across" label="Sticker Across" placeholder="" input-classes="form-control" required/>
                <base-input v-model="description.gap" label="Gap" placeholder="" input-classes="form-control" required/>
                <base-input v-model="description.barcode_type" label="Barcode Type" placeholder="" input-classes="form-control" required/>
                <base-input v-model="barcodeTemplate.max_char" label="Row Length" placeholder="" type="number" input-classes="form-control" required/>
                <base-input v-if="this.currentAction != 'view'" alternative="" label="Barcode Format" required class="pb-4 mb-5">
                    <a-upload-dragger :before-upload="beforeUpload"
                    :remove="handleRemove"
                    :fileList="file"
                    :multiple="false" accept=".bar, .BAR">
                        <span class="fa fa-file-import" style="font: 20pt;" />
                        <p class="ant-upload-text">Click or drag file to this area to upload</p>
                        <p class="ant-upload-hint">
                            Upload your Barcode Template in a BAR file format.
                            Please add {name},{barcode},{price} & {quantity} on your file.
                        </p>
                    </a-upload-dragger>
                </base-input>
            </fieldset>
            <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" v-if="currentAction == 'add'" :disable="spinning" class="btn btn-primary float-right" @click.prevent="create">
                        <a-spin :spinning="spinning"/> Save
                    </button>
                    <button type="button" v-if="currentAction == 'edit'" :disable="spinning" class="btn btn-primary float-right" @click.prevent="update">
                        <a-spin :spinning="spinning"/> Update
                    </button>
            </div>
        </a-drawer>
    </div>
</template>


<script>
    var component_x;
    import { mapState, mapActions } from 'vuex'
    import secureStorage from "../../controllers/secureStorage.js"
    import ValidateField from '../../components/validateFormUtils.js'
    import HTTPRequest from '../../controllers/httpRequest.js'
    import axios from "axios"

    export default {
        data: function () {
            return {
                drawerVisible:false,
                barcodeTemplate:{
                    name:null,
                    description:null,
                    max_char:null,
                },
                description:{
                    printer_model:null,
                    sticker_size:null,
                    sticker_across:null,
                    gap:null,
                    barcode_type:null,
                },
                file:[],
                spinning:false,
                barcodeTemplateErrors:[],
                barcodeTemplateList:[],
                columns:[
                    {
                        title: 'Name',
                        dataIndex: 'name',
                    },
                    {
                        title: 'Description',
                        dataIndex: 'description',
                    },
                    {
                        title: 'Row length',
                        dataIndex: 'max_char',
                    },
                    {
                        title: 'Status',
                        dataIndex: 'status',
                    },
                    {
                        title: 'Action',
                        key: "action",
                        scopedSlots: { customRender: 'action' },
                    },
                ],
                selectedTemplateId:null,
                currentAction:null,
            }
        },
        mounted: async function(){
            component_x = this
            await this.getTemplateList()
        },
        computed: {
            ...mapState(['endPoint', 'publicUrl'])
        },
        methods:{
            showDrawer(action){
                this.currentAction = action;
                this.drawerVisible = true;
            },
            closeDrawer(){
                this.emptyFields();
                this.drawerVisible = false;
            },
            async create(){
                this.spinning = true;
                this.mergeDescription();
                if(!this.barcodeTemplateValidation()) {
                    let data = new FormData();
                    data.append('file', component_x.file[0]);
                    
                    //Get S3 uploader endpoint
                    var uploader_endpoint = await HTTPRequest.getRequest(this.endPoint + 'settings/api_s3_uploader', null, null)
                    var config = {
                        method: 'post',
                        url: `${uploaderEndpoint.endpoint}?profile=Barcode Printing Templates&account_name=${accountName}`,
                        // url: 'https://yg2ogthup9.execute-api.ap-southeast-1.amazonaws.com/bxi-staging-2/uploads/STAGING2-S3?profile=Barcode Printing Templates&account_name=' + secureStorage.getItem("accountName"),
                        headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken")},
                        // headers: {'Authorization': 'Bearer SwM5bqWcxCSXqjdfAW9a2SDV4eClHC9K1uDXcqTeT1Q'},
                        data : data
                    };
                    var response_data;
                    await axios(config)
                        .then(function (response) {
                            response_data = response.data
                        })
                        .catch(function (error) {
                            //console.log(error)
                    });
                    var barcodeTemplate = this.barcodeTemplate
                    barcodeTemplate.file_url = response_data.path || ''

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'barcode_printing_templates', null, barcodeTemplate)
                    if (post_request["error"] == undefined){
                        this.$notification['success']({
                            message: 'Successfully Added',
                        });
                        this.closeDrawer();
                        this.getTemplateList();
                    } else {
                        this.barcodeTemplateErrors = post_request["error"].split(",")
                    }
                }
                this.spinning = false;
            },
            mergeDescription(){
                this.barcodeTemplate.description = "";
                this.barcodeTemplate.description += "Printer Model: "+this.description.printer_model;
                this.barcodeTemplate.description += ", Sticker Size: "+this.description.sticker_size;
                this.barcodeTemplate.description += ", Sticker Across: "+this.description.sticker_across;
                this.barcodeTemplate.description += ", Gap: "+this.description.gap;
                this.barcodeTemplate.description += ", Barcode Type: "+this.description.barcode_type;
            },
            splitDescription(){
                var description = this.barcodeTemplate.description
                var splitedDesc = description.split(", ")
                splitedDesc.forEach(val => {
                    var splitVal = val.split(": ")
                    if (splitVal[0] == "Printer Model")
                        this.description.printer_model = splitVal[1];
                    if (splitVal[0] == "Sticker Size")
                        this.description.sticker_size = splitVal[1];
                    if (splitVal[0] == "Sticker Across")
                        this.description.sticker_across = splitVal[1];
                    if (splitVal[0] == "Gap")
                        this.description.gap = splitVal[1];
                    if (splitVal[0] == "Barcode Type")
                        this.description.barcode_type = splitVal[1];
                });
            },
            viewBarcodeTemplate(data){
                this.barcodeTemplate.name = data.name
                this.barcodeTemplate.description = data.description
                this.barcodeTemplate.max_char = data.max_char
                this.selectedTemplateId = data.id
                this.showDrawer('view')
                this.splitDescription();
            },
            editBarcodeTemplate(data){
                this.barcodeTemplate.name = data.name
                this.barcodeTemplate.description = data.description
                this.barcodeTemplate.max_char = data.max_char
                this.selectedTemplateId = data.id
                this.showDrawer('edit')
                this.splitDescription();
            },
            emptyFields(){
                this.barcodeTemplate.name = null
                this.barcodeTemplate.description = null
                this.description = {
                    printer_model:null,
                    sticker_size:null,
                    sticker_across:null,
                    gap:null,
                    barcode_type:null,
                },
                this.barcodeTemplate.max_char = null
                this.selectedTemplateId = null
                this.barcodeTemplateErrors = []
            },
            async update(){
                this.spinning = true;
                this.mergeDescription();
                if(!this.barcodeTemplateValidation()) {
                    var barcodeTemplate = this.barcodeTemplate
                    if(this.file.length > 0){
                        let data = new FormData();
                        data.append('file', component_x.file[0]);
                        
                        //Get S3 uploader endpoint
                        var uploader_endpoint = await HTTPRequest.getRequest(this.endPoint + 'settings/api_s3_uploader', null, null)
                        var config = {
                            method: 'post',
                            url: `${uploaderEndpoint.endpoint}?profile=Barcode Printing Templates&account_name=${accountName}`,
                            // url: 'https://yg2ogthup9.execute-api.ap-southeast-1.amazonaws.com/bxi-staging-2/uploads/STAGING2-S3?profile=Barcode Printing Templates&account_name=' + secureStorage.getItem("accountName"),
                            headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken")},
                            // headers: {'Authorization': 'Bearer SwM5bqWcxCSXqjdfAW9a2SDV4eClHC9K1uDXcqTeT1Q'},
                            data : data
                        };
                        var response_data;
                        await axios(config)
                            .then(function (response) {
                                response_data = response.data
                            })
                            .catch(function (error) {
                                //console.log(error)
                        });
                        barcodeTemplate.file_url = response_data.path || ''
                    }
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'barcode_printing_templates/'+this.selectedTemplateId, null, barcodeTemplate)
                    if (put_request["error"] == undefined){
                        this.$notification['success']({
                            message: 'Successfully Updated',
                        });
                        this.closeDrawer();
                        this.getTemplateList();
                    } else {
                        this.barcodeTemplateErrors = put_request["error"].split(",")
                    }
                }
                this.spinning = false;
            },
            barcodeTemplateValidation(){
                this.barcodeTemplateErrors = [];
                this.barcodeTemplateErrors.push(ValidateField.required('Name', this.barcodeTemplate.name));
                this.barcodeTemplateErrors.push(ValidateField.alphanumericWithSpecialChars('Name', this.barcodeTemplate.name));
                this.barcodeTemplateErrors.push(ValidateField.required('Printer Model', this.description.printer_model));
                this.barcodeTemplateErrors.push(ValidateField.required('Sticker Size', this.description.sticker_size));
                this.barcodeTemplateErrors.push(ValidateField.required('Sticker Across', this.description.sticker_across));
                this.barcodeTemplateErrors.push(ValidateField.required('Gap', this.description.gap));
                this.barcodeTemplateErrors.push(ValidateField.required('Barcode Type', this.description.barcode_type));
                this.barcodeTemplateErrors.push(ValidateField.required('Row Length', this.barcodeTemplate.max_char));
                this.barcodeTemplateErrors.push(ValidateField.numericRequired('Row Length', this.barcodeTemplate.max_char));
                if(this.currentAction == 'add'){    
                    this.barcodeTemplateErrors.push(ValidateField.isEmpty('Barcode Format', this.file));
                }
                this.barcodeTemplateErrors = this._.compact(this.barcodeTemplateErrors);
                return this.barcodeTemplateErrors.length;
            },
            async getTemplateList(){
                var response = await HTTPRequest.getRequest(this.endPoint + 'barcode_printing_templates', null)
                this.barcodeTemplateList = response.data
            },
            async deleteBarcodeTemplate(id){
                await axios({
                    method: 'delete',
                    url: `${this.endPoint}/barcode_printing_templates/${id}`,
                    headers: {
                    Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
                    },
                }).then(({ data: { status, message } }) => {
                    if (status == 'D') {
                        this.$notification['success']({
                            message: 'Successfully Deleted',
                        });
                        this.getTemplateList()
                    } else {
                        this.$notification['error']({
                            message: 'Error',
                            description: message,
                        });
                    }
                })
            },
            beforeUpload(file) {
                this.file = [];
                const reader = new FileReader();
                var errors = []
                reader.onload = e => {
                    var text = e.target.result;
                    var name = true,barcode = true,price = true;
                    console.log(text)
                    if (!text.includes("{name}")){
                        name  = false;
                        errors.push("{name} is required. please include to your file. ")
                    }
                    if (!text.includes("{barcode}")){
                        barcode  = false;
                        errors.push("{barcode} is required. please include to your file.")
                    }
                    if (!text.includes("{price}")){
                        price  = false;
                        errors.push("{price} is required. please include to your file. ")
                    }
                    if (!text.includes("{quantity}")){
                        price  = false;
                        errors.push("{quantity} is required. please include to your file. ")
                    }
                    if (name && barcode && price){
                        component_x.file = [file];
                    }else{
                        this.barcodeTemplateErrors = errors;
                    }
                };
                reader.readAsText(file);
                return false;
            },
            handleRemove(file) {
                const index = this.file.indexOf(file);
                const newFileList = this.file.slice();
                newFileList.splice(index, 1);
                this.file = newFileList;
            },
        }
    }
</script>

<style>
</style>